import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

const UploadIcon = ({ ...props }) => {
    return (React.createElement(SvgIcon, { ...props, viewBox: "0 0 16 16" },
        React.createElement("path", { d: "M8.99989 14.857L8.99987 8.7637H10.8979C11.3433 8.7637 11.5664 8.2252 11.2515 7.91025L8.35351 5.01224C8.15825 4.81698 7.84167 4.81698 7.64641 5.01224L4.74849 7.91016C4.43351 8.22514 4.65659 8.7637 5.10204 8.7637H6.99999V14.8569C6.99999 15.1632 6.72348 15.4098 6.42205 15.3554C2.87742 14.7165 0.5 11.9264 0.5 8.24618V7.75393C0.5 3.54873 3.59869 0.500018 8 0.500018C12.4013 0.500018 15.5 3.54982 15.5 7.75393V8.24618C15.5 11.9274 13.1225 14.7167 9.57778 15.3555C9.27637 15.4098 8.99989 15.1632 8.99989 14.857Z" })));
};

export { UploadIcon };
//# sourceMappingURL=UploadIcon.esm.js.map
